module.exports = __webpack_public_path__ + "img/Bahrain.7d3f90ce.svg";